import React from "react";
import StoryLayout from "./StoryLayout";
import { TRIAL_CONTEXT } from "../../../data/icfSeed";

// The "everything is calm" scene — trial context + a soft grid of 87
// green dots representing all participants signed on ICF v3.1.

const dots = Array.from({ length: 87 });
const ticker = [
    "Site 03 · V4 dosed",
    "Site 07 · V2 baseline",
    "Site 05 · V6 completed",
    "Site 01 · V3 scheduled",
    "Site 09 · V5 dosed",
    "Site 04 · V4 dosed",
    "Site 11 · V2 baseline",
    "Site 08 · V6 completed",
];

export default function StorySetup() {
    return (
        <StoryLayout
            slideNumber={2}
            eyebrow="The state of the world · April 2026"
            nextTo="/icf/story/amendment"
            prevTo="/icf/story"
            nextLabel="Then something changes"
            testid="story-setup"
        >
            <h1 className="heading text-3xl md:text-5xl font-medium tracking-tighter leading-tight max-w-4xl">
                ONCO-247 is running clean.
            </h1>
            <p className="text-[14px] md:text-[15px] text-neutral-600 mt-6 leading-relaxed max-w-3xl">
                Phase II. NSCLC. Twelve sites open, 87 participants enrolled,
                ICF v3.1 IRB-approved and signed by everyone. Sponsor QA is
                quiet. Sites are enrolling on schedule.
            </p>

            {/* trial context strip — reused from IcfLayout */}
            <div className="mt-10 border border-hair bg-white">
                <div className="px-6 py-4 flex items-center gap-x-8 gap-y-2 overflow-x-auto">
                    {[
                        { k: "Trial", v: TRIAL_CONTEXT.trial_id },
                        { k: "Phase", v: TRIAL_CONTEXT.phase },
                        { k: "Sponsor", v: TRIAL_CONTEXT.sponsor },
                        { k: "Sites", v: TRIAL_CONTEXT.sites },
                        { k: "Enrolled", v: `${TRIAL_CONTEXT.participants} pts` },
                        { k: "Master ICF", v: TRIAL_CONTEXT.master_icf },
                        { k: "IRB", v: TRIAL_CONTEXT.irb },
                    ].map((f) => (
                        <div key={f.k} className="shrink-0">
                            <div className="overline text-[9px]">{f.k}</div>
                            <div className="text-[12px] mono text-neutral-700 mt-[2px]">
                                {f.v}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="border-t border-hair px-6 py-6">
                    <div className="overline mb-4">
                        87 participants · all signed on ICF v3.1
                    </div>
                    <div className="grid grid-cols-[repeat(auto-fill,minmax(18px,1fr))] gap-1.5">
                        {dots.map((_, i) => (
                            <div
                                key={i}
                                className="aspect-square rounded-sm bg-[#DCFCE7] border border-[#86EFAC]"
                                style={{
                                    animation: `pulseDot 3s ease-in-out infinite`,
                                    animationDelay: `${(i % 20) * 0.15}s`,
                                }}
                            />
                        ))}
                    </div>
                    <style>{`
                        @keyframes pulseDot {
                            0%, 100% { opacity: 1; }
                            50% { opacity: 0.55; }
                        }
                    `}</style>
                </div>

                <div className="border-t border-hair px-6 py-3 overflow-hidden">
                    <div
                        className="flex gap-8 mono text-[11px] text-neutral-500"
                        style={{
                            animation: "ticker 30s linear infinite",
                            whiteSpace: "nowrap",
                            width: "max-content",
                        }}
                    >
                        {[...ticker, ...ticker, ...ticker].map((t, i) => (
                            <span key={i} className="shrink-0">
                                {t}
                            </span>
                        ))}
                    </div>
                    <style>{`
                        @keyframes ticker {
                            from { transform: translateX(0); }
                            to { transform: translateX(-33%); }
                        }
                    `}</style>
                </div>
            </div>

            <p className="text-[16px] text-neutral-800 mt-10 italic max-w-3xl">
                Then something changes.
            </p>
        </StoryLayout>
    );
}
